import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface NotificationMessage {
    id: string;
    content: React.ReactNode;
    className?: string;
}

const BuildNotificationBar: React.FC = () => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    const messages: NotificationMessage[] = [
        {
            id: 'build-tips',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    Take your time — precision makes perfect headphones
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'progress-encouragement',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    You're building something amazing
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'safety-reminders',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    Work in a well-lit area for best results
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'community',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    Join 500+ builders who've completed their Kibu headphones
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'support',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    Stuck? Each step has a video tutorial to guide you through
                </div>
            ),
            className: "bg-orange-600"
        },
        {
            id: 'achievement',
            content: (
                <div className="flex w-full items-center gap-2 font-headline">
                    Every step brings you closer to your own pair of headphones
                </div>
            ),
            className: "bg-orange-600"
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentMessageIndex((prevIndex) =>
                prevIndex === messages.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [messages.length]);

    const currentMessage = messages[currentMessageIndex];

    return (
        <div className={`flex h-[28px] md:h-[34px] w-full text-white text-center items-center justify-center text-[14px] font-headline overflow-hidden transition-colors duration-500 ${currentMessage.className}`}>
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.div
                    key={currentMessage.id}
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -30, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="w-full whitespace-nowrap px-4 flex items-center justify-center"
                >
                    <div className="inline-flex items-center justify-center gap-2">
                        {currentMessage.content}
                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default BuildNotificationBar;